import React, { useState } from 'react'
import CMS from '../CMS/CMS'
import { useForm } from 'react-hook-form'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from '@tanstack/react-query'
import Swal from 'sweetalert2'
import { Form } from 'react-bootstrap'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import  { CKEditor} from '@ckeditor/ckeditor5-react'

const PrivacyPolicy = () => {

    const {handleSubmit,formState: { errors }} = useForm({})
    const [currentCmsId, setCurrentCmsId] = useState()
    const [ckeditordata, setckeditordata] = useState(null)
    function handleCKEditor(event, editor) {
        const data = editor.getData()
        setckeditordata(data)
    }
    async function getPrivacyPolicy() {
        return requestApi.get(
            `/cms/list?slug=terms-conditions`,
            {}
        ).then((res) => {
            setCurrentCmsId(res?.data?.data?.cmsId)
            setckeditordata(res?.data?.data)
            return res?.data?.data
        })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['CMSlist'],
        queryFn: getPrivacyPolicy
    })

    async function addEditPolicy(payload) {
        return requestApi.post(
            `/cms/edit`,
            { ...payload, 
                cmsId: currentCmsId,
                title:'Terms & Conditions'
            },
            { },
            true
        )
    }
    const editMutation = useMutation(addEditPolicy, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: error?.message
            })
        }
    })

    const onEditSubmit = (data) => {
        const payload = {
            description: ckeditordata
        }
        editMutation.mutate(payload)
    }

    return (
        <>
     
        <CMS>
            <div className='head'>
                <h2>Terms & Conditions</h2>
            </div>
            <div className='support-body-content'>
                <Form onSubmit={handleSubmit(onEditSubmit)}>
                    <div div className='form-group'>
                              <CKEditor
                        //  data={ckeditordata || ''}
                        data={ckeditordata?.description?.length >= 0 ? ckeditordata?.description : ckeditordata}
                            removePlugins="ckeditor_logo"
                            editor={ClassicEditor}
                            config={{
                                removePlugins: [
                                    'EasyImage',
                                    'ImageUpload',
                                    'MediaEmbed',
                                    'insertTable',
                                ],
                                 allowedContent:true,
                                toolbar: [
                                    'heading',
                                    '|',
                                    'bold',
                                    'italic',
                                    'link',
                                    'bulletedList',
                                    'numberedList',
                                    // "blockQuote",
                                    // 'ckfinder',
                                    '|',
                                    // 'imageTextAlternative',
                                    // 'imageUpload',
                                    // 'imageStyle:full',
                                    // 'imageStyle:side',
                                    // '|',
                                    // 'mediaEmbed',
                                    // 'insertTable',
                                    // "tableColumn",
                                    // "tableRow",
                                    // "mergeTableCells",
                                    '|',
                                    'undo',
                                    'redo'
                                ]
                            }}
                            onReady={(editor) =>
                                // ckeditordata?.description
                                 console.log(editor.getData(), 'hello')
                            }
                            onChange={handleCKEditor}
                        />
                    </div>
                    <button type="submit" className='solid-red-btn'>Save</button>
                </Form>
            </div>
        </CMS>
        </>
    )
}
export default PrivacyPolicy